import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import Button from '@/components/button'
import FormField from '@/components/form-field'
import { Input } from '@/components/input'
import AuthLayout from '@/layouts/auth-layout'
import { AuthApi } from '@/services/api-routes'
import { notifyErrorFor, notifySuccess } from '@/utility/notify'
import styles from './style.module.css'

const schema = yup.object({
  email: yup.string().email('Informe um e-mail válido').required('Preencha o e-mail'),
})

type ForgotPasswordForm = yup.InferType<typeof schema>

const ForgotPassword = () => {
  const [isEnviado, setIsEnviado] = useState(false)

  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    register,
  } = useForm<ForgotPasswordForm>({
    resolver: yupResolver(schema),
    defaultValues: { email: '' },
  })

  const onSubmit = async ({ email }: ForgotPasswordForm) => {
    try {
      await AuthApi.esqueciMinhaSenha(email)
      setIsEnviado(true)
      notifySuccess('Encontramos sua conta. Siga as instruções enviadas para o seu contato.')
    } catch (error) {
      notifyErrorFor('recuperar a senha', error)
    }
  }

  return (
    <AuthLayout
      title="Esqueceu a senha?"
      subtitle="Informe o e-mail da sua conta do backoffice"
      footer={<Link to="/login">Voltar para o login</Link>}
    >
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)} noValidate>
        <FormField label="E-mail" htmlFor="email" required error={errors.email?.message}>
          <Input
            id="email"
            type="email"
            autoComplete="email"
            placeholder="Preencha o e-mail"
            invalid={Boolean(errors.email)}
            {...register('email')}
          />
        </FormField>

        <Button type="submit" size="lg" block isLoading={isSubmitting} disabled={isEnviado}>
          Enviar
        </Button>
      </form>
    </AuthLayout>
  )
}

export default ForgotPassword
